define('app-FindByProductCode/viewModel',['./settings', "util", 'knockout', 'jquery-ui', '../app/knockoutExtensions/expandAndCollapse'], function (settings, util, ko) {
    return function (productCode) {
        var self = this;

        // Properties
        self.InputProductCode = ko.observable(productCode);
        // 1 = product found, 0 = suggestions found, anything else is the default state.
        self.productFound = ko.observable(2);
        self.productAlt = ko.observable('');
        self.productImgUrl = ko.observable('');
        self.productName = ko.observable('');
        self.productUrl = ko.observable('');
        self.productDreamline = ko.observable('');
        self.productOffer = ko.observable('');
        self.loading = ko.observable(false);
        self.suggestions = ko.observableArray([]);

        // Methods

        self.FindNewProducts = ko.computed(function () {
            var productCode = self.InputProductCode();

            // Only bother with the network traffic if the user has actually typed something that looks like a product code.
            if (productCode.length !== 5) return;

            self.loading(true);

            // Pass this value off to the back end to see what products we get back, if any.
            $.get(settings.productSearchUrl, { code: productCode.toUpperCase() }, function (result) {
                if (result.product) {
                    // We've got a match, let's display it.
                    self.productFound(1);
                    self.productAlt(result.product.alt);
                    self.productImgUrl(result.product.imgUrl);
                    self.productName(result.product.name);
                    self.productUrl(result.product.url);
                    self.productDreamline(result.product.dreamline);
                    self.productOffer(result.product.offer);
                    //
                    // Find by product code - add vars to the data layer & make the direct call to get them picked up
                    AdlAddUpdateItem('brochureCode', productCode.toUpperCase());
                    AdlAddUpdateItem('bookingDestination', result.product.name);
                    //direct call
                    util.satelliteTrack('search by brochure');

                } else {
                    self.productFound(0);
                    // no products found - test to see if we have some suggested alternatives to so display them instead.
                    self.suggestions(result.suggestedAlternatives);
                }

                self.loading(false);
            });
        }, this);

        self.goToProduct = function () {
            if (self.productUrl() != "") {
                //update the ADL and make the direct call
                AdlAddUpdateItem('BHsearchMethodWidgetType', 'brochure_code');
                AdlAddUpdateItem('BHsearchMethodLinkType', 'text');
                AdlAddUpdateItem('BHsearchMethodPagePosition', 'header');
                AdlAddUpdateItem('BHsearchMethodPageType', 'homepage');
                util.satelliteTrack('travelSearchWidget');

                var url = self.productUrl();
                window.location.href = url;
            }
        };

        self.selectSuggestedValue = function (suggestionProductCode) {
            return function () {
                self.InputProductCode(suggestionProductCode);
            };
        };
    };
});
